import React, { useEffect, useState } from 'react'
import { ContractsTable } from './table/ContractsTable'
import { RegistrationEmployerContract } from '@features/contracts/registrationEmployerContract'
import ContractSearch from '@features/contracts/search/contractsSearch'
import { contractsThunks } from '@/entity/contracts'
import { useDispatch, useSelector } from 'react-redux'
import { userSelectors } from '@/entity'
import { HrPagination } from '@/components/Pagination'
import { getFromLocalStorage } from '@/shared'

const queryInitialState = {
	page: 0,
	pageSize: 10,
	rowsPerPage: [
		{ size: 10, label: '10' },
		{ size: 30, label: '30' },
		{ size: 50, label: '50' },
		{ size: 100, label: '100' },
	],
}

const initialFilterState = {
	bin: null,
	iin: null,
	companyName: null,
	contractNumber: null,
	dateFrom: null,
	dateTo: null,
	dcontractStateCode: null,
	dcontractStatusCode: null,
	dcontractTypeCode: null,
	dsendStatusCode: null,
	employeeName: null,
	establishedPost: null,
	registerDate: null,
	sortDirection: 'desc',
	sortField: "entryDate",
	srcText: null,
	terminationDate: null,
	representative: false,
	employee: false,
}

export const EmploymentContracts = ({ setActiveTab }) => {
	const dispatch = useDispatch()

	const { role, contractsData, user } = useSelector((state) => ({
		role: userSelectors.activeRole(state),
		contractsData: state.contracts,
		user: state.user.user
	}))

	const activeCompany = getFromLocalStorage('activeCompany')

	const [queryParams, setQueryParams] = useState(queryInitialState)
	const [filters, setFilters] = useState(initialFilterState)

	useEffect(() => {
		if (role) {
			dispatch(contractsThunks.getOptions())
			getContractsData(initialFilterState, queryParams.page, queryParams.pageSize, true)
		}
	}, [role])

	const getContractsData = (params = initialFilterState, page = queryParams.page, pageSize = queryParams.pageSize, cache = false) => {
		setFilters(params)

		let bodyParams = {
			ROLE_EMPLOYER: {bin: activeCompany?.bin},
			ROLE_EMPLOYEE: {iin: user?.iin},
		}

		dispatch(
			contractsThunks.getContracts(
				{
					...initialFilterState,
					...params,
					...bodyParams[role]
				},
				page,
				pageSize,
				cache
			)
		)
	}

	const handleChangePage = (e, page) => {
		setQueryParams({ ...queryParams, page: page - 1 })

		getContractsData(filters, page - 1, queryParams.pageSize)
	}

	const handleChangeRowsPerPage = (size) => {
		setQueryParams((prev) => ({ ...prev, page: 0, pageSize: size }))

		getContractsData(filters, 0, size)
	}

	return (
		<>
			<RegistrationEmployerContract
				fetchData={getContractsData}
				setFilters={setFilters}
				filters={filters}
				page={queryParams.page}
				pageSize={queryParams.pageSize}
			/>
			<ContractSearch fetchData={getContractsData} filters={filters} page={queryParams.page} pageSize={queryParams.pageSize}/>
			<ContractsTable
				page={queryParams.page}
				pageSize={queryParams.pageSize}
				filters={filters}
				setFilters={setFilters}
				fetchData={getContractsData}
				setActiveTab={setActiveTab}
			/>
			<HrPagination
				id="hr-pagination"
				rowsPerPageitems={queryParams.rowsPerPage}
				rowsPerPage={queryParams.pageSize}
				numberOfElements={contractsData?.numberOfElements}
				totalElements={contractsData?.totalElements}
				totalPages={contractsData?.totalPages}
				handleChangePage={handleChangePage}
				handleChangeRowsPerPage={handleChangeRowsPerPage}
				page={queryParams.page}
			/>
		</>
	)
}
